var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14256 11.84L12.7614 7.32L11.5965 6.18L8.14256 9.56L6.42581 7.88L5.26087 9.02L8.14256 11.84ZM9.00094 17C7.10706 16.5333 5.54359 15.47 4.31053 13.81C3.07747 12.15 2.46094 10.3067 2.46094 8.28V3.4L9.00094 1L15.5409 3.4V8.28C15.5409 10.3067 14.9244 12.15 13.6913 13.81C12.4583 15.47 10.8948 16.5333 9.00094 17Z",
    fill: "#16A02C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.7ac4be567b87a2ab7e90150a11206809.svg";
export { ForwardRef as ReactComponent };